import { AfterSaleMode, AfterSaleState, ButtonGroupStatus } from '@/types';

export default {
  /**
   * 根据售后订单状态获取配置信息
   * @param state - 售后数据
   * @param callbacks - 订单相关操作的回调函数
   */
  getConfig: (data: AnyObject | null, callbacks: AnyObject, buttonSize: number[] = [192, 74]) => {
    if (!data?.state) return [];

    const modifyApplyButton = {
      text: '修改申请',
      status: ButtonGroupStatus.active,
      size: buttonSize,
      onClick: callbacks['modifyApply'],
    };

    const cancelApplyButton = {
      text: '撤销申请',
      status: ButtonGroupStatus.normalA,
      size: buttonSize,
      onClick: callbacks['cancelApply'],
    };

    const confirmReceiptButton = {
      text: '确认收货',
      status: ButtonGroupStatus.active,
      size: buttonSize,
      onClick: callbacks['confirmReceipt'],
    };

    const modifyLogisticsButton = {
      text: '修改物流',
      status: ButtonGroupStatus.active,
      size: buttonSize,
      onClick: callbacks['modifyLogistics'],
    };

    const config: AnyObject = {
      // 提交申请 => [撤销申请，修改申请]
      [AfterSaleState.submit]: [cancelApplyButton, modifyApplyButton],
      // 商家同意申请,等待用户退货 => [撤销申请]
      [AfterSaleState.waitingForDelivery]: [cancelApplyButton],
      // 用户已退货,等待商家收货 => [撤销申请， 修改物流]
      [AfterSaleState.goodsToBeReceived]: [cancelApplyButton, modifyLogisticsButton],
      // 商家拒绝退款 =>  [撤销申请， 修改申请]
      [AfterSaleState.refusalOfRefund]: [cancelApplyButton, modifyApplyButton],
      // 商家拒绝收货 =>  [撤销申请， 修改物流]
      [AfterSaleState.refusalOfGoods]: [cancelApplyButton, modifyLogisticsButton],
      // 商家确认收货并发货 => [确认收货]
      [AfterSaleState.confirmReceiptAndDelivery]: [confirmReceiptButton],
      // 商家同意退款 => []
      [AfterSaleState.agreeToRefund]: [],
      // 退款成功 => []
      [AfterSaleState.successfulRefund]: [],
      // 售后取消 => []
      [AfterSaleState.cancel]: [],
    };

    return config[data.state];
  },
  /**
   * 获取售后状态显示文本
   * @param state - 售后状态
   */
  getStateText: (data: AnyObject | null) => {
    if (!data) return '';

    // 是否换货模式
    const isExchange = data.mode === AfterSaleMode.exchangeGoods;
    const state = data.state;

    const config: AnyObject = {
      [AfterSaleState.submit]: '申请已提交，等待处理中',
      [AfterSaleState.waitingForDelivery]: '寄回商品',
      [AfterSaleState.goodsToBeReceived]: '待仓库确认',
      [AfterSaleState.refusalOfRefund]: '申请已拒绝',
      [AfterSaleState.refusalOfGoods]: '申请已拒绝',
      [AfterSaleState.confirmReceiptAndDelivery]: '商家已发货',
      [AfterSaleState.agreeToRefund]: '同意退款',
      [AfterSaleState.successfulRefund]: '退款成功',
      [AfterSaleState.complete]: isExchange ? '换货成功' : '退款成功',
      [AfterSaleState.cancel]: isExchange ? '换货关闭' : '退款关闭',
    };

    return config[state];
  },
  /**
   * 根据售后模式获取对应文本
   * @param mode
   */
  getModeText: (mode: AfterSaleMode) => {
    return mode === AfterSaleMode.exchangeGoods
      ? '换货'
      : mode === AfterSaleMode.refundOnly
      ? '仅退款'
      : '退货退款';
  },
};
